import React from "react";
import { Link } from "react-router-dom";
import { SlickSlider } from "../SlickSlider/SlickSlider";
import { HOME_HERO } from "../../content/siteContent";

export const SliderAreaOne = () => {
  const heroBackground = "/images/home/hero_bg.jpg";

  const slick_settings_brands = {
    autoplay: false,
    autoplaySpeed: 10000,
    dots: false,
    fade: true,
    arrows: false,
    responsive: [{ breakpoint: 767, settings: { dots: false, arrows: false } }],
  };

  return (
    <section className="slider-area">
      <div className="slider-active">
        <SlickSlider settings={slick_settings_brands}>
          {[1].map((item) => (
            <div
              key={item}
              className="single-slider slider-bg"
              style={{
                backgroundColor: "#f4f4f4",
              }}
            >
              <img
                src={heroBackground}
                alt=""
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: -2,
                }}
              />
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(rgba(4, 15, 34, 0.1), rgba(4, 15, 34, 0.18))",
                  zIndex: -1,
                }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="slider-content home-hero-animated">
                      <span
                        className="sub-title hero-animate-item"
                        data-animation="fadeInUp"
                        data-delay=".2s"
                      >
                        {HOME_HERO.eyebrow}
                      </span>
                      <h1
                        className="title hero-animate-item"
                        data-animation="fadeInUp"
                        data-delay=".4s"
                      >
                        {HOME_HERO.title}
                      </h1>
                      <p
                        className="hero-animate-item"
                        data-animation="fadeInUp"
                        data-delay=".6s"
                      >
                        {HOME_HERO.description}
                      </p>
                      <div
                        className="d-flex flex-wrap gap-3 hero-animate-item"
                        data-animation="fadeInUp"
                        data-delay=".8s"
                      >
                        <Link to={HOME_HERO.primaryCta.href} className="btn">
                          {HOME_HERO.primaryCta.label}
                        </Link>
                        <Link
                          to={HOME_HERO.secondaryCta.href}
                          className="btn transparent-btn"
                        >
                          {HOME_HERO.secondaryCta.label}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </SlickSlider>
      </div>
    </section>
  );
};
